export const userProfile = {
  forgottenPassword: {
    passwordResetEmailSent:
      'Eine Email zur Passwortzurücksetzung wurde an ihre Emailadresse gesendet.',
  },
};
